var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { HubPlace } from '../../../../models/hub/hub.place';
import { ImageService } from '../../../../services/image.service';
import { PlaceDetailsModalComponent } from '../../place.details.modal/place.details.modal.component';
import { PlaceDetailsModalActions } from '../../place.details.modal/place.details.modal.provider';
import { TripDetailModalActions, TripDetailModalData } from '../../trip/trip.detail.modal/trip.detail.modal.provider';
import { TripDetailModalComponent } from '../../trip/trip.detail.modal/trip.detail.modal.component';
import { PlaceService } from '../../../../services/place.service';
var VisitorLargerCardComponent = /** @class */ (function (_super) {
    __extends(VisitorLargerCardComponent, _super);
    function VisitorLargerCardComponent(router, imageService, modalService, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.imageService = imageService;
        _this.modalService = modalService;
        _this.activatedRoute = activatedRoute;
        _this.eventTimeText = '';
        _this.placeCategory = '';
        _this.isNoImage = false;
        return _this;
    }
    VisitorLargerCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        if (this.item.startTime) {
            this.eventTimeText = this.isMobile
                ? this.item.startTimeFormatted
                : "" + this.item.startTimeFormatted + (this.item.endTimeFormatted ? ' - ' + this.item.endTimeFormatted : '');
        }
        else {
            if (this.item['categoryList']) {
                this.placeCategory = '';
                var cate = '';
                for (var _i = 0, _a = this.item['categoryList']; _i < _a.length; _i++) {
                    var category = _a[_i];
                    cate += category + ', ';
                    if (cate.length < 44) {
                        this.placeCategory = cate;
                    }
                }
                this.placeCategory = this.placeCategory.substr(0, this.placeCategory.length - 2);
            }
        }
        setTimeout(function () {
            if (!_this.item.cover || !_this.item.cover.source) {
                _this.isNoImage = true;
            }
        });
    };
    VisitorLargerCardComponent.prototype.toReadable = function (code) {
        return PlaceService.toReadableCategory(code);
    };
    VisitorLargerCardComponent.prototype.enterItemByKeyboard = function ($event) {
        if ($event && $event.key === 'Enter') {
            this.showDetails();
        }
    };
    VisitorLargerCardComponent.prototype.showDetails = function () {
        if (this.item.isPromotionImage) {
            this.item.promotionLink = this.item.promotionLink.startsWith('http')
                ? this.item.promotionLink
                : 'http://' + this.item.promotionLink;
            window.open(this.item.promotionLink, '_blank');
            return;
        }
        if (!this.isMobile) {
            var actions = {
                confirm: function (event, data) {
                },
            };
            this.modalService.show({
                component: PlaceDetailsModalComponent,
                providers: [
                    { provide: PlaceDetailsModalActions, useValue: actions },
                    { provide: HubPlace, useValue: this.item },
                ],
                panelClass: 'modal-fixed-top',
            });
        }
        else {
            this.showDetailModalForMobile(this.item, 'place');
        }
    };
    VisitorLargerCardComponent.prototype.showDetailModalForMobile = function (item, displayingOn, isShowAddToTripBtn, index) {
        if (isShowAddToTripBtn === void 0) { isShowAddToTripBtn = false; }
        var actions = {
            confirm: function (event) {
            },
        };
        this.modalService.show({
            component: TripDetailModalComponent,
            providers: [
                { provide: TripDetailModalActions, useValue: actions },
                {
                    provide: TripDetailModalData,
                    useValue: new TripDetailModalData(item, displayingOn, this.hubName, null, null, isShowAddToTripBtn, index),
                },
            ],
            panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
        });
    };
    VisitorLargerCardComponent.prototype.remove = function () {
    };
    return VisitorLargerCardComponent;
}(BaseComponent));
export { VisitorLargerCardComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/larger.card/visitor.larger.card.component.ts.pre-build-optimizer.js